import { z } from 'zod'
import { oc } from '@orpc/contract'

export const deleteIncomingFax = oc
  .route({ method: 'DELETE', path: '/v2/incoming-faxes/{id}' })
  .input(z.object({ id: z.string() }))
  // Returns the empty object on success (including idempotent "already gone").
  // The model returns a boolean internally but it's not surfaced to clients —
  // a successful 2xx is the success contract, and real failures throw.
  .output(z.object({}))
